import { Component, OnInit } from '@angular/core';
import { PriceDisplayService } from '../price-display.service';
import { PriceDisplayMode } from '../../../shared/enums/price-display-mode.enum';

@Component({
  standalone: false,
  selector: 'price-display-label',
  templateUrl: './price-display-label.component.html'
})
export class PriceDisplayLabelComponent implements OnInit {
  public pointsLabel: string;
  public showLabel: boolean;

  constructor(private priceDisplayService: PriceDisplayService) { }

  ngOnInit() {
    if (this.priceDisplayService.getPriceDisplayMode() === PriceDisplayMode.Points){
      this.pointsLabel = this.priceDisplayService.getCurrencyLabel();
      this.showLabel = true;
    } else {
      this.showLabel = false;
    }
  }

}
